// extracted by mini-css-extract-plugin
module.exports = {"newInterviewBtnWrapper":"MyVideoEditRequestTable_newInterviewBtnWrapper__DbfdM","detailsModalLink":"MyVideoEditRequestTable_detailsModalLink__QGpf9"};